<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCplocalidad" role="form" method="post" autocomplete="off" onSubmit="return false">	
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpLocalidad.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpLocalidad.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdEstado">Estado</label>
							<select @change="SetClaveEstado" v-model="objCpLocalidad.IdEstado" class="form-control-search form-select" id="IdEstado">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in Estados" :key="index" :value="item.IdEstado">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdEstado" :Mensaje="'*'+errorvalidacion.IdEstado[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="ClaveEstado">ClaveEstado</label>
							<input disabled type="text" v-model="objCpLocalidad.ClaveEstado" class="form-control" id="ClaveEstado" placeholder="Ingresar ClaveEstado" />
							<CValidation v-if="this.errorvalidacion.ClaveEstado" :Mensaje="'*'+errorvalidacion.ClaveEstado[0]"/>
						</div>
					</div>

					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpLocalidad',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpLocalidad: {
				IdLocalidad: 0,
				IdEstado: 0,
				IdMunicipio: 0,
				Clave: '',
				ClaveEstado: '',
				Nombre: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Estados: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpLocalidad.IdLocalidad == 0) {
				await this.$http.post(
					'cpLocalidades',this.objCpLocalidad
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpLocalidades/'+this.objCpLocalidad.IdLocalidad,
					this.objCpLocalidad
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpLocalidades/"+this.objCpLocalidad.IdLocalidad
            ).then((res) => {
                this.objCpLocalidad = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpLocalidad.Fecha.replace(/-/g,'\/');
                this.objCpLocalidad.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpLocalidad = {
				IdLocalidad: 0,
				IdEstado: 0,
				IdMunicipio: 0,
				Clave: '',
				ClaveEstado: '',
				Nombre: '',
            }
            this.errorvalidacion = [];
        },
		GetEstados()
		{
			this.$http.get("cpEstados", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.Estados = res.data.data;
			});
		},
		SetClaveEstado(){
			let index=this.Estados.findIndex((Estado)=>Estado.IdEstado==this.objCpLocalidad.IdEstado);
			this.objCpLocalidad.ClaveEstado=this.Estados[index].Clave;
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

			this.GetEstados();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpLocalidad.IdLocalidad = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
